import { faker } from '@faker-js/faker';
import { HttpResponse, delay, http } from 'msw';

import { getPlatformListLocalUsersResponseMock } from 'shared/base';

import { getCustomHandlerLoginStatus } from './utils';
import { MOCK_DELAY } from './utils/constants';

export const getCustomPlatformListLocalUsersMockHandler = () => {
  return http.get('*/manage/users', async () => {
    await delay(MOCK_DELAY);

    if (!getCustomHandlerLoginStatus()) {
      return new HttpResponse(null, { status: 401 });
    }

    const items = [
      {
        created_at: `${faker.date.past().toISOString().split('.')[0]}Z`,
        email: 'admin@localhost',
        enabled: true,
        id: faker.string.uuid(),
        is_admin: true,
        last_login_at: `${faker.date.past().toISOString().split('.')[0]}Z`,
        name: 'Admin',
        profile_image_url: undefined,
        updated_at: `${faker.date.past().toISOString().split('.')[0]}Z`,
      },
      ...getPlatformListLocalUsersResponseMock().items,
    ];

    return HttpResponse.json(
      {
        ...getPlatformListLocalUsersResponseMock(),
        items,
        metadata: {
          ...getPlatformListLocalUsersResponseMock().metadata,
          total_count: items.length + 1,
        },
      },
      {
        status: 200,
      },
    );
  });
};
